module.exports = __webpack_public_path__ + "static/media/promo-tender.b3ed7649.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-tender.jpg
// module id = 321
// module chunks = 0